/*
Se necesita este fichero para poder vincular cada dominio a su respectiva API.
*/

// export const URLIDENTITY = 'https://ilusionaClubIdentityserver.azurewebsites.net'
export const URLIDENTITY = 'https://ilusiona-identityserver-prod.azurewebsites.net'

export const URL = () => {
  let url = window.location.origin
  // console.log(url)
  switch (url) {
    case 'http://localhost:3000':
      // url = "https://3aguas-api.azurewebsites.net/api";
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      // url = "https://localhost:5001/api";
      break
    case 'https://fidelizacion.ilusiona.com':
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'https://club.ilusiona.com':
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'https://tcg.ilusiona.com':
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'https://ilusiona-redemption.azurewebsites.net':
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'http://debug-n-ilu.azurewebsites.net':
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'https://ilusiona-web.azurewebsites.net':
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'https://ilusiona-inventario.azurewebsites.net':
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'https://3aguas-redemption.azurewebsites.net':
      // url = 'https://3aguas-api.azurewebsites.net/api/'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    case 'http://3aguas-tcg.azurewebsites.net':
      // url = 'https://3aguas-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
    default:
      // url = 'https://ilusiona-api.azurewebsites.net/api'
      url = 'https://ilusiona-api-prod.azurewebsites.net/api'
      break
  }
  return url
  // return window.location.origin;
}
// export var URL = urlTest("agua");
export const LOCAL = false
